require([
],
    function () {

        function initAllCarouselsOnPage() {
            // process all elements with selector #carousel_...
            $("div[id^='carousel_']").each(function (index, swiperContainer) {
                var data = $(swiperContainer).data();
                var swiperParameters = {
                    // Optional parameters
                    loop: false,
                    slidesPerView: data.numberOfVisibleSlides ? data.numberOfVisibleSlides : 'auto',
                    spaceBetween: 20,
                    effect: data.transitionEffect,
                    speed: data.transitionTime,
                    // Pagination
                    pagination: {
                        el: '#' + $(swiperContainer).attr('id') + ' .swiper-pagination',
                        clickable: true
                    },

                    // Navigation arrows
                    navigation: {
                        nextEl: '#' + $(swiperContainer).attr('id') + ' .swiper-button-next',
                        prevEl: '#' + $(swiperContainer).attr('id') + ' .swiper-button-prev'
                    }
                };
                if (swiperParameters.slidesPerView !== 'auto') {
                    // reduce number of visible slides on smaller screens
                    swiperParameters.breakpoints = {
                        // on large screens (width >= 1024px ) we keep the initial number of visible slides
                        1024: {
                            slidesPerView: data.numberOfVisibleSlides
                        },
                        // on smaller screens ( 768px <= width < 1024px ) we lower the number of visible slides by 1 (if possible)
                        768: {
                            slidesPerView: (data.numberOfVisibleSlides - 1) > 0 ? (data.numberOfVisibleSlides - 1) : 1
                        },
                        // on really small screens ( 0 <= width < 768px ) we lower the number of visible slides by 2 (if possible)
                        0: {
                            slidesPerView: (data.numberOfVisibleSlides - 2) > 0 ? (data.numberOfVisibleSlides - 2) : 1
                        }
                    };
                }
                if (data.autoplaySeconds) {
                    swiperParameters.autoplay = { delay: data.autoplaySeconds * 1000 };
                }
                var swiper = new Swiper(swiperContainer, swiperParameters);
            });

        }

        initAllCarouselsOnPage();

    }
);

define("Carousel/main", function(){});

